<template>
  <div class="recent-actions">
    <div ref="reference" style="padding: 0 15px; text-align: right; padding-top: 10px;padding-bottom: 10px;">
      <i class="fix-icon iconfont" :class="fixed ? 'icon-jiesuo' : 'icon-suoding1'" @click="changeFixed" />
    </div>
    <div class="recent-actions-title has-right">
      <span class="recent-actions-title-text">
        <i class="iconfont icon-zuijincaozuo star-icon" style="font-size: 20px; transform: translate(-3px, 0);" />
        <span>{{ $t('common.recentActions') }}</span>
      </span>
    </div>
    <div class="recent-actions-box">
      <div
        v-for="child in recentMenus"
        :key="child.id"
        class="recent-actions-item"
        :class="{ 'is-active': isActive(child.vueUrl) }"
        @click="chooseMenu(child)"
      >{{ child.name }}</div>
    </div>
    <div class="recent-actions-title has-right" @mouseenter="show" @mouseleave="hide">
      <span class="recent-actions-title-text">
        <i class="el-icon-menu" style="font-size: 20px; color: #008EE3; transform: translate(-3px, 0);" />
        {{ $t('common.allFunctions') }}
      </span>
      <i class="el-icon-arrow-right" />
    </div>
    <transition name="el-fade-in-linear" @after-leave="doDestroy">
      <div v-show="showPopper" ref="popper" class="recent-actions-popper" @mouseenter="show" @mouseleave="hide">
        <div :style="sizeStyle">
          <all-menus @choose-menu="chooseMenu" @un-fixed-menu="$emit('un-fixed-menu')" @fixed-menu="$emit('fixed-menu')" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Popper from 'element-ui/src/utils/vue-popper'
import AllMenus from './all-menus'
export default {
  components: {
    AllMenus
  },
  mixins: [Popper],
  props: {
    sizeStyle: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      timeout: null
    }
  },
  computed: {
    recentMenus() {
      return this.$store.getters.recentMenus.map(key => {
        return this.$store.getters.menusMap[key]
      }).filter(menu => menu)
    },
    fixed() {
      return this.$store.getters.fixedMenu
    }
  },
  methods: {
    changeFixed() {
      this.$store.commit('app/SET_FIXED_MENU', !this.fixed)
    },
    isActive(name) {
      if (!name) return false
      const route = this.$route
      if (name === route.name) return true
      if (name === route.meta.dep) return true
      return false
    },
    show() {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.showPopper = true
        this.$nextTick(() => {
          this.$emit('show-menus', this.$refs.popper.scrollHeight)
        })
      }, 250)
    },
    hide() {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.showPopper = false
        this.$nextTick(() => {
          this.$emit('hide-menus', 0)
        })
      }, 250)
    },
    chooseMenu(menu) {
      this.showPopper = false
      this.$emit('choose-menu', menu)
    }
  }
}
</script>

<style lang="scss" scoped>
.recent-actions {
  .fix-icon {
    cursor: pointer;
  }
  .star-icon {
    font-size: 20px;
    color: rgb(146, 208, 81);
  }
  &-title {
    cursor: pointer;
    padding: 0px 15px;
    font-size: 14px;
    line-height: 45px;
    font-weight: 700;
    display: flex;
    align-items: center;
    &.has-right {
      justify-content: space-between;
    }
    &:hover {
      background: #e9f0f5;
    }
    &-text {
      margin-left: 4px;
      display: flex;
      align-items: center;
    }
  }
  &-box {
    padding-left: 32px;
    padding-bottom: 6px;
  }
  &-item {
    cursor: pointer;
    display: inline-block;
    vertical-align: top;
    width: 40%;
    height: 25px;
    overflow: hidden;
    margin-bottom: 5px;
    margin-left: 3px;
    font-size: 12px;
    line-height: 20px;
    color: #666;
    &:hover {
      color: #5b9bd1;
      font-weight: 600;
    }
    &.is-active {
      color: #008ee3;
      font-weight: 600;
    }
  }

  &-popper {
    margin-top: -5px;
    background: #fff;
    box-shadow: 0px 0px 2px 1px #eee;
  }
}
</style>
